// toxilibs/soundjs_adapter imports 'soundjs', an esbuild alias to this file (see esbuild_config.js)
import createjs from 'toxilibs/extlibs/soundjs.js'


export default createjs.Sound
